import React, { useEffect, useState } from "react"
import "./EditTask.scss"
import { useLocation } from "react-router-dom"
import TaskApi from "Api/TaskApi"
import { Button, Card, CardBody, Col, Row, Spinner } from "reactstrap"
import { useNavigate } from "react-router-dom"
import CustomBreadCrumb from "utils/CustomBreadCrumb/CustomBreadCrumb"
import { InputText } from "primereact/inputtext"
import { Dropdown } from "primereact/dropdown"

const EditTask = () => {
  document.title = "Edit Task"
  const [loading, setLoading] = useState(false)
  const location = useLocation()
  const navigate = useNavigate()
  const accessToken = localStorage.getItem("accessToken")
  const taskDataLoc = location?.state
  console.log("taskDataLoc", taskDataLoc)

  const refinedTask = {
    ...taskDataLoc,
    priority: {
      name:
        taskDataLoc.priority.charAt(0).toUpperCase() +
        taskDataLoc.priority.slice(1).toLowerCase(),
      code:
        taskDataLoc.priority.charAt(0).toUpperCase() +
        taskDataLoc.priority.slice(1).toLowerCase(),
    },
    taskCategory: {
      name:
        taskDataLoc.taskCategory.charAt(0).toUpperCase() +
        taskDataLoc.taskCategory.slice(1).toLowerCase(),
      code:
        taskDataLoc.taskCategory.charAt(0).toUpperCase() +
        taskDataLoc.taskCategory.slice(1).toLowerCase(),
    },
  }

  const [taskData, setTaskData] = useState(refinedTask)

  const [errors, setErrors] = useState({})

  const handleTaskChange = (name, value) => {
    setTaskData(prevData => ({ ...prevData, [name]: value }))
    // setTaskData({ ...taskData, [name]: value });
    setErrors({ ...errors, [name]: "" })
    console.log("check calender")
  }

  const taskCategoryOptions = [
    { name: "University", code: "University" },
    { name: "Institution", code: "Institution" },
    { name: "Program", code: "Program" },
    { name: "Course", code: "Course" },
  ]

  const priorityOptions = [
    { name: "High", code: "High" },
    { name: "Medium", code: "Medium" },
    { name: "Low", code: "Low" },
  ]

  const [analystMenu, setAnalystMenu] = useState([])
  const getAnalystDropdown = () => {
    const config = {
      headers: { Authorization: `Bearer ${accessToken}` },
    }

    TaskApi.getAnalystUser(config)
      .then(res => {
        setAnalystMenu(res.data.users)
      })
      .catch(error => {
        console.error("Error fetching analysts:", error)
      })
  }

  useEffect(() => {
    getAnalystDropdown()
  }, [accessToken])

  const updateTask = () => {
    const payload = {
      ...taskData,
      taskCategory: taskData.taskCategory.name.toLowerCase(),
      priority: taskData.priority.name.toLowerCase(),
      assignTo: taskData.assignTo._id,
      taskId: taskData._id,
    }

    const config = {
      headers: { Authorization: `Bearer ${accessToken}` },
    }

    setLoading(true)
    TaskApi.updateTask(payload, config)
      .then(res => {
        if (res.data.status) {
          setLoading(false)
          navigate("/taskList")
        }
      })
      .catch(error => {
        setLoading(false)
        console.log(error)
      })
  }

  const breadcrumbItems = [
    { label: "Pixwik", link: "#" },
    { label: "Task", link: "#" },
    { label: "Edit Task", link: "#" },
  ]

  return (
    <div className="assign-Task">
      <Row>
        <Col xs="12">
          <div className="task-list-header d-flex  align-items-center justify-content-between">
            <CustomBreadCrumb data={breadcrumbItems} pageTitle="Edit Task" />
          </div>

          <Card className="mt-4 ">
            <CardBody>
              <div className="task-edit-form">
                <div className="task-edit-inp">
                  <label htmlFor="taskName" className="label">
                    Task Name
                  </label>
                  <div className="inp-err">
                    <InputText
                      id="taskName"
                      value={taskData.taskName}
                      onChange={e =>
                        handleTaskChange("taskName", e.target.value)
                      }
                      placeholder="Enter Task Name"
                      className="inp-field-box"
                    />
                    {errors.taskName && (
                      <small className="error">{errors.taskName}</small>
                    )}
                  </div>
                </div>

                <div className="task-edit-inp">
                  <label htmlFor="taskCategory">TaskCategory</label>
                  <div className="inp-err">
                    <Dropdown
                      id="taskCategory"
                      value={taskData.taskCategory}
                      onChange={e => handleTaskChange("taskCategory", e.value)}
                      optionLabel="name"
                      options={taskCategoryOptions}
                      placeholder=" select Task Category"
                    />
                    {errors.taskCategory && (
                      <small className="error">{errors.taskCategory}</small>
                    )}
                  </div>
                </div>

                <div className="task-edit-inp">
                  <label htmlFor="target" className="label">
                    Target
                  </label>
                  <div className="inp-err">
                    <InputText
                      id="target"
                      value={taskData.target}
                      onChange={e => handleTaskChange("target", e.target.value)}
                      placeholder="Enter Target"
                      className="inp-field-box"
                    />
                    {errors.target && (
                      <small className="error">{errors.target}</small>
                    )}
                  </div>
                </div>

                <div className="task-edit-inp">
                  <label htmlFor="startDate" className="label">
                    Start Date
                  </label>
                  <div className="inp-err">
                    <InputText
                      id="startDate"
                      value={taskData.startDate}
                      onChange={e =>
                        handleTaskChange("startDate", e.target.value)
                      }
                      placeholder="Enter Start Date"
                      className="inp-field-box"
                    />
                    {/* <Calendar value={startDate} onChange={(e) => setStartDate(e.value)} dateFormat="dd/mm/yy" /> */}
                    {errors.startDate && (
                      <small className="error">{errors.startDate}</small>
                    )}
                  </div>
                </div>

                <div className="task-edit-inp">
                  <label htmlFor="dueDate" className="label">
                    Due Date
                  </label>
                  <div className="inp-err">
                    <InputText
                      id="dueDate"
                      value={taskData.dueDate}
                      onChange={e =>
                        handleTaskChange("dueDate", e.target.value)
                      }
                      placeholder="Enter Due Date"
                      className="inp-field-box"
                    />
                    {/* <Calendar
                                  id="dueDate"
                                  value={taskData.dueDate}
                                  onChange={e =>
                                      handleTaskChange("dueDate", e.value)
                                  }
                                  placeholder="Select Due Date"
                                  className="inp-field-box"
                              /> */}
                    {errors.dueDate && (
                      <small className="error">{errors.dueDate}</small>
                    )}
                  </div>
                </div>

                <div className="task-edit-inp">
                  <label htmlFor="priority">Priority</label>
                  <div className="inp-err">
                    <Dropdown
                      id="priority"
                      value={taskData.priority}
                      onChange={e => handleTaskChange("priority", e.value)}
                      optionLabel="name"
                      options={priorityOptions}
                      placeholder=" select Priority"
                    />
                    {errors.priority && (
                      <small className="error">{errors.priority}</small>
                    )}
                  </div>
                </div>

                <div className="task-edit-inp">
                  <label htmlFor="assignTo">AssignTo</label>
                  <div className="inp-err">
                    <Dropdown
                      id="assignTo"
                      value={taskData.assignTo}
                      onChange={e => handleTaskChange("assignTo", e.value)}
                      optionLabel="userName"
                      options={analystMenu}
                      placeholder="Select Analyst"
                    />
                    {errors.assignTo && (
                      <small className="error">{errors.assignTo}</small>
                    )}
                  </div>
                </div>

                <div className="task-edit-inp">
                  <label htmlFor="remarks" className="label">
                    Remarks
                  </label>
                  <div className="inp-err">
                    <InputText
                      id="remarks"
                      value={taskData.remarks}
                      onChange={e =>
                        handleTaskChange("remarks", e.target.value)
                      }
                      placeholder="Enter Remarks"
                      className="inp-field-box"
                    />
                    {errors.remarks && (
                      <small className="error">{errors.remarks}</small>
                    )}
                  </div>
                </div>
              </div>

              <div className="save-cancel-btn mt-4 d-flex align-items-center justify-content-end gap-3">
                <Button
                  type="button"
                  outline
                  color="danger"
                  className="waves-effect waves-light"
                  onClick={() => {
                    navigate(-1)
                  }}
                >
                  Cancel
                </Button>
                <Button
                  type="button"
                  color="secondary"
                  className="waves-effect waves-light"
                  onClick={() => {
                    updateTask()
                  }}
                >
                  {loading ? <Spinner size="sm" /> : "Save"}
                </Button>
              </div>
            </CardBody>
          </Card>
        </Col>
      </Row>
    </div>
  )
}

export default EditTask
